import {
  captureException as captureExceptionSentry,
  setUser as sentrySetUser,
} from '@sentry/nextjs';
import env from '~/env.public';

import { UUID } from '@trucksmarter/shared';

export function setSentryUser(user: { id: UUID }) {
  sentrySetUser(user);
}

export function captureException(
  error: any,
  extraContext: Record<string, unknown> = {},
) {
  if (env.ENABLE_CONSOLE_LOGS) {
    console.error(error);
  }

  captureExceptionSentry(error, {
    extra: extraContext,
  });
}
